import type { ApiRequestParams } from '@/domains/api/api.entity';
import { apiClient } from './apiClient';

/**
 * Servicio para realizar peticiones HTTP a una API
 */
export const apiRequest = {
  /**
   * Realizar una petición GET a la API
   * @param params -> parametros de la petición
   * @param params.route -> Ruta de la petición
   * @param [params.param] -> Parámetro opcional para la petición
   */
  async get<T>({
    route,
    param,
    params,
  }: ApiRequestParams<undefined>): Promise<T> {
    const url = param ? `${route}${param}` : route;
    const response = await apiClient.get<T>(url, { params });
    return response.data;
  },

  /**
   * Realizar una peticion POST a la API
   * @param params -> parametros de la petición
   * @param params.route -> Ruta de la petición
   * @param params.payload -> Datos a enviar en el cuerpo de la petición
   */
  async post<T, P>({ route, payload }: ApiRequestParams<P>): Promise<T> {
    const response = await apiClient.post<T>(route, payload);
    return response.data;
  },

  /**
   * Realizar una petición PUT a la API
   * @param params -> parametros de la petición
   * @param params.route -> Ruta de la petición
   * @param params.payload -> Datos a enviar en el cuerpo de la petición
   * @param [params.param] -> Parámetro opcional para la petición
   */
  async put<T, P>({ route, payload, param }: ApiRequestParams<P>): Promise<T> {
    // const url = `${route}${param}`;
    const url = param ? `${route}${param}` : route;
    const response = await apiClient.put<T>(url, payload);
    return response.data;
  },

  /**
   * Realizar una petición DELETE a la API
   * @param params -> parametros de la petición
   * @param params.route -> Ruta de la petición
   * @param [params.param] -> Parámetro opcional para la petición
   */
  async delete<T>({ route, param }: ApiRequestParams<undefined>): Promise<T> {
    const url = `${route}${param}`;
    const response = await apiClient.delete<T>(url);
    return response.data;
  },
};
